import { getEdgeColor } from '@/utils/graph-data'

const LEGEND_ITEMS = [
  { type: 'related', label: 'Related' },
  { type: 'causes', label: 'Causes' },
  { type: 'follows', label: 'Follows' },
  { type: 'confirms', label: 'Confirms' },
  { type: 'contradicts', label: 'Contradicts' },
  { type: 'pattern', label: 'Pattern' },
] as const

export function MemoryGraphLegend() {
  return (
    <div className="pointer-events-none absolute bottom-4 left-4 z-10 rounded-lg border border-border/40 bg-background/85 p-2 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <p className="mb-1.5 text-[10px] font-medium text-muted-foreground">Relations</p>
      <ul className="space-y-1">
        {LEGEND_ITEMS.map((item) => (
          <li key={item.type} className="flex items-center gap-2 text-[10px]">
            <span
              className="inline-block h-0.5 w-4 shrink-0 rounded-full"
              style={{ backgroundColor: getEdgeColor(undefined, item.type) }}
              aria-hidden
            />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
